import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_SUBSCRIPTION_DURATION_SAGA } from "../sagaTypes";
import { loaderAction, subscriptionDurationFormAction, typeOpenSettingsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionDataSagaAction } from "../sagaActions";
import { SUBSCRIPTION_DURATION_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/duration_update_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateSubscriptionDuration(args) {
    const user = yield select(state => state.user);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);
        formData.append('name', args.data.name);
        formData.append('establishments', args.data.establishments);
        formData.append('interval', args.data.interval);
        formData.append('freeze_days', args.data.freeze_days);
        formData.append('freeze_times', args.data.freeze_times);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму
            yield put(typeOpenSettingsFormAction(''));
            // Сбрасываем данные в форме типа абонемента
            yield put(subscriptionDurationFormAction(SUBSCRIPTION_DURATION_FORM_INITIAL));
            // Получаем обновлённый список типов абонементов
            yield put(getSubscriptionDataSagaAction());
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateSubscriptionDuration() {
    yield takeLatest(UPDATE_SUBSCRIPTION_DURATION_SAGA, workerUpdateSubscriptionDuration);
}